import { postRawRequest } from '../../httpClient';
import type { IMatchSubtitleV1Params } from './match-subtitle-v1-request';

const ONE_HOUR_MS = 3_600_000;

export async function matchSubtitleV1Api({
  subtitleId,
  force,
}: IMatchSubtitleV1Params): Promise<Response> {
  const query = force ? '?force=true' : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/match/v1${query}`,
    options: { timeout: ONE_HOUR_MS },
  });
}
